export const getInitials = text =>
  text && text
    .split(/\s+/)
    .map(word => word[0])
    .filter(letter => letter != null)
    .join('')
    .substring(0, 4)
    .toUpperCase();

export const randomColor = () =>
  `#${Math.floor(Math.random() * 16777215).toString(16)}`;

export const formatAccount = (account, color) => ({
    ...account,
    initialsColor: color,
    label: account.organizationName,
    initials: getInitials(account.organizationName)
  });

export const colors = ['#960F1A', '#079407', '#222B7E', '#E17614'];
export const formatAccounts = (accounts) =>
  accounts.map((account, i) => formatAccount(
    account,
    colors[i] || randomColor()
  ));

export const formatGroups = (organizations, currentUserId) =>
  organizations.map(org => ({
      ...org,
      userGroups: org?.groups?.filter(g => g?.members?.some(m => m?.personId === currentUserId)) || []
    })
  );
